import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ 'white-space': _ctx.truncate ? _ctx.nowrap : 'break-spaces' }),
    class: _normalizeClass({ 'truncatable-text': _ctx.truncate })
  }, _toDisplayString(_ctx.textDisplay), 7))
}